export default __webpack_public_path__ + "static/media/right-arrow.b07559a5.svg";